import { useEffect } from 'react'

interface UsePageTitleOptions {
  agencyName?: string | null
  pageTitle?: string
  defaultTitle?: string
}

export const usePageTitle = ({
  agencyName,
  pageTitle,
  defaultTitle = 'Rolt - Conta'
}: UsePageTitleOptions) => {
  useEffect(() => {
    if (agencyName && pageTitle) {
      document.title = `${agencyName} - ${pageTitle}`
    } else if (agencyName) {
      document.title = `${agencyName} - Dashboard`
    } else if (pageTitle) {
      document.title = `Rolt - ${pageTitle}`
    } else {
      document.title = defaultTitle
    }
  }, [agencyName, pageTitle, defaultTitle])
}
